<div class="container col-12">

  <div class="card">
    <h3 class="title-h4-blue">Cambiar contraseña</h3>
    <hr />
    <form [formGroup]="loginForm" (ngSubmit)="onChangePassword()">
      <!-- Contraseña actual -->
      <div class="input-cont">
        <div class="input-container">
          <input
            class="input-reservas"
            type="password"
            id="contrasenaActual"
            name="contrasenaActual"
            placeholder="Contraseña actual"
            formControlName="contrasenaActual"
            appPasswordToggle
          />
          <label for="contrasenaActual" class="input-label"
            >Contraseña nueva</label
          >
          <img src="./assets/password-g.svg" alt="" />
        </div>
      </div>
      <!-- Contraseña Nueva -->
      <div class="input-cont">
        <div class="input-container">
          <input
            class="input-reservas"
            type="password"
            id="contrasenaNueva"
            name="contrasenaNueva"
            placeholder="Nueva contraseña"
            formControlName="contrasenaNueva"
            appPasswordToggle
          />
          <label for="contrasenaNueva" class="input-label"
            >Contraseña nueva</label
          >
          <img src="./assets/password-g.svg" alt="" />
        </div>
      </div>
      <!-- Confirmar contraseña -->
      <div class="input-cont">
        <div class="input-container">
          <input
            class="input-reservas"
            type="password"
            id="confirmarContrasena"
            name="confirmarContrasena"
            placeholder="Confirmar contraseña"
            formControlName="confirmarContrasena"
            appPasswordToggle
          />
          <label for="confirmarContrasena" class="input-label"
            >Confirmar contraseña</label
          >
          <img src="./assets/password-g.svg" alt="" />
        </div>
      </div>
      <!-- Agregar después del último input de contraseña y antes del botón -->
      <div class="password-requirements">
        @for(requirement of passwordRequirements; track requirement.key) {
        <div class="requirement" [class.met]="requirement.met">
          <i
            class="bi"
            [class.bi-check-circle-fill]="requirement.met"
            [class.bi-circle]="!requirement.met"
          ></i>
          <span>{{ requirement.message }}</span>
        </div>
        }
      </div>
      <!-- Modificar el botón para incluir la validación de requisitos -->
      <button
        class="button-main"
        [disabled]="!loginForm.valid || !allRequirementsMet"
        type="submit"
      >
        Guardar
      </button>
    </form>
  </div>
</div>

<app-modal-envio-correcto
  [isOpen]="showModal"
  message="Contraseña cambiada exictosamente"
  (continue)="onContinue()"
></app-modal-envio-correcto>

<!-- Modales -->

@if(isSameActual){
<div class="modal-container">
  <div class="modal-cont">
    <img src="./assets/warning.svg" alt="" />
    <p>No puedes colocar la misma contraseña</p>
    <button class="btn-m-new" (click)="isSameActual = false">Cerrar</button>
  </div>
</div>
} @if(isSameNew){
<div class="modal-container">
  <div class="modal-cont">
    <img src="./assets/warning.svg" alt="" />
    <p>No puedes colocar una contraseña utilizada anteriormente</p>
    <button class="btn-m-new" (click)="isSameNew = false">Cerrar</button>
  </div>
</div>
} @if(isSameConfirm){
<div class="modal-container">
  <div class="modal-cont">
    <img src="./assets/warning.svg" alt="" />
    <p>Las contraseñas no coinciden</p>
    <button class="btn-m-new" (click)="isSameConfirm = false">Cerrar</button>
  </div>
</div>
} @if(error){
<div class="modal-container">
  <div class="modal-cont">
    <img src="./assets/warning.svg" alt="" />
    <p>Error al cambiar contraseña</p>
    <button class="btn-m-new" (click)="error = false">Cerrar</button>
  </div>
</div>
}
